import { StyledSelect } from "../common.style";
import { Option } from "../../primitives";
import { CARDMARKET_SELLER_ACOUNTRY_CODE } from "magic-shared-types";

interface CountryDropdownProps {
  country: string;
  setCountry: (arg1: string) => void;
}

export const CountryDropdownCardMarket = ({
  setCountry,
  country,
}: CountryDropdownProps) => {
  return (
    <StyledSelect value={country} onChange={(e) => setCountry(e.target.value)}>
      <Option value="">All Country</Option>
      {CARDMARKET_SELLER_ACOUNTRY_CODE.map((country) => (
        <Option value={country.name}>{country.name}</Option>
      ))}
    </StyledSelect>
  );
};
